import { defineComponent as _defineComponent } from 'vue'
import Navigation from "@/components/NavigationContainer.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();


const __returned__ = { Navigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})